import { render, staticRenderFns } from "./EditPaperPagesV2.vue?vue&type=template&id=44a32614&scoped=true"
import script from "./EditPaperPagesV2.vue?vue&type=script&lang=js"
export * from "./EditPaperPagesV2.vue?vue&type=script&lang=js"
import style0 from "./EditPaperPagesV2.vue?vue&type=style&index=0&id=44a32614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a32614",
  null
  
)

export default component.exports